import React from "react";
import PublicInfoLayout from "./PublicInfoLayout";

const rows = [
  { feature: "Precio", free: "0 €", pro: "2,99 €/mes o 29 €/año" },
  { feature: "Inicio", free: "30 días de prueba completa", pro: "Activación inmediata" },
  { feature: "Cuentas bancarias", free: "Hasta 1", pro: "Sin límite" },
  { feature: "Tarjetas", free: "Hasta 1", pro: "Sin límite" },
  { feature: "Movimientos al mes", free: "Hasta 50", pro: "Sin límite" },
  { feature: "Reglas automáticas", free: "Hasta 3", pro: "Sin límite" },
  { feature: "Histórico", free: "3 meses", pro: "Completo" },
  { feature: "Análisis y plan de ahorro", free: "Básico", pro: "Completo" },
  { feature: "Portal de facturas", free: "No", pro: "Sí" },
];

const structuredData = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "Precios y límites Free/Pro | Ahorra y respira",
  url: "https://ahorrayrespira.com/precios-y-limites",
  description: "Comparativa simple de funcionalidades incluidas en Free y Pro.",
  inLanguage: "es-ES",
  mainEntity: {
    "@type": "OfferCatalog",
    name: "Planes de suscripción",
    itemListElement: [
      { "@type": "Offer", name: "Plan Free", price: "0", priceCurrency: "EUR" },
      { "@type": "Offer", name: "Plan Pro mensual", price: "2.99", priceCurrency: "EUR" },
      { "@type": "Offer", name: "Plan Pro anual", price: "29", priceCurrency: "EUR" },
    ],
  },
};

export default function PricingLimitsPage() {
  return (
    <PublicInfoLayout
      title="Precios y límites Free/Pro"
      subtitle="Comparativa simple para que sepas qué incluye cada plan antes de decidir."
      updatedAt="18 de febrero de 2026"
      canonicalPath="/precios-y-limites"
      structuredData={structuredData}
    >
      <section className="panel">
        <h2 className="panel-title">Comparativa Free vs Pro</h2>
        <div className="pricing-comparison-wrap">
          <table className="results-table pricing-comparison-table">
            <thead>
              <tr>
                <th className="compare-feature-head">Funcionalidad</th>
                <th className="compare-free-head">Free</th>
                <th className="compare-pro-head">Pro</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(row => (
                <tr key={row.feature}>
                  <td className="compare-feature-cell">{row.feature}</td>
                  <td className="compare-free-cell">{row.free}</td>
                  <td className="compare-pro-cell">{row.pro}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section className="panel">
        <h2 className="panel-title">Preguntas habituales sobre planes</h2>
        <p>
          Empiezas con 30 días de prueba gratuita completa, con todas las funciones disponibles.
          Al terminar, se aplican límites del plan Free y puedes pasar a Pro para mantenerlo todo activo.
        </p>
      </section>
    </PublicInfoLayout>
  );
}
